import BaseModel from "./BaseModel";

export default class ImportProductsTask extends BaseModel {

    static data_name = 'import_products_tasks';

     static async startSiteImport(potential_site){
        let instance = new this();
        instance.potential_site_document_id = potential_site.document_id;
        instance.import_all_sites = false;
        instance.message = "";
        await instance.save();
        return instance;
    }

    static async startAllSitesImport(){
        let instance = new this();
        instance.import_all_sites = true;
        instance.message = "";
        await instance.save();
        return instance;
    }
}